// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tasks_task_description__M2Dv5 {
  .p-accordion-header:not(.p-disabled) .p-accordion-header-link {
    background: #fafafa;
    border: none;
  }

  .p-accordion-tab {
    border: 1px solid var(--branded-purple-border);
    border-radius: 8px;
  }

  .p-accordion-content {
    background: #fafafa;
    padding: 0.6rem 1rem;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}

.Tasks_due_date_help_icon__krTWi {
  font-size: 10px;
  cursor: pointer;
  border: 2px solid grey;
  border-radius: 100%;
  padding: 2px;
}

.Tasks_btn_mark_complete__VBBd8 {
  border-radius: 20px;
  padding-bottom: 10px;
  padding-right: 14px;
  font-weight: 400;
  font-size: 0.82rem;

  &:hover {
    background-color: #6d3092;
  }
}

.p-tabview .p-tabview-panels {
  padding: 0;
}

.Tasks_past_due_tag__CsOEj .p-tag-value,
.Tasks_past_due_tag__CsOEj .p-tag-icon {
  font-weight: 500;
}

.Tasks_filters_button__8OK0u {
  background-color: #ffffff !important;
  border: 1px solid var(--branded-purple) !important;
  color: var(--branded-font-color) !important;
  border-radius: 4px;
  height: 40px;
  width: 150px;
  grid-area: filters-button;
  margin-right: 5px;
}

.Tasks_btn_task_action__S6iwB {
  font-size: 0.82rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/Tasks.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,8CAA8C;IAC9C,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kDAAkD;EAClD,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".task_description {\n  :global(.p-accordion-header:not(.p-disabled) .p-accordion-header-link) {\n    background: #fafafa;\n    border: none;\n  }\n\n  :global(.p-accordion-tab) {\n    border: 1px solid var(--branded-purple-border);\n    border-radius: 8px;\n  }\n\n  :global(.p-accordion-content) {\n    background: #fafafa;\n    padding: 0.6rem 1rem;\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n  }\n}\n\n.due_date_help_icon {\n  font-size: 10px;\n  cursor: pointer;\n  border: 2px solid grey;\n  border-radius: 100%;\n  padding: 2px;\n}\n\n.btn_mark_complete {\n  border-radius: 20px;\n  padding-bottom: 10px;\n  padding-right: 14px;\n  font-weight: 400;\n  font-size: 0.82rem;\n\n  &:hover {\n    background-color: #6d3092;\n  }\n}\n\n:global(.p-tabview .p-tabview-panels) {\n  padding: 0;\n}\n\n.past_due_tag :global(.p-tag-value),\n.past_due_tag :global(.p-tag-icon) {\n  font-weight: 500;\n}\n\n.filters_button {\n  background-color: #ffffff !important;\n  border: 1px solid var(--branded-purple) !important;\n  color: var(--branded-font-color) !important;\n  border-radius: 4px;\n  height: 40px;\n  width: 150px;\n  grid-area: filters-button;\n  margin-right: 5px;\n}\n\n.btn_task_action {\n  font-size: 0.82rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"task_description": `Tasks_task_description__M2Dv5`,
	"due_date_help_icon": `Tasks_due_date_help_icon__krTWi`,
	"btn_mark_complete": `Tasks_btn_mark_complete__VBBd8`,
	"past_due_tag": `Tasks_past_due_tag__CsOEj`,
	"filters_button": `Tasks_filters_button__8OK0u`,
	"btn_task_action": `Tasks_btn_task_action__S6iwB`
};
export default ___CSS_LOADER_EXPORT___;
